import React from 'react';
import { useI18n } from '@olxeu-a2b/ui/src/i18n';
import S from '@olxeu-a2b/ui/src/commons/components/style/InfoModal';
import { InfoModalDescriptionTextKeys } from './types';

interface InfoModalLowerDescriptionProps {
  lowerDescriptionTextKeys: InfoModalDescriptionTextKeys;
}

const InfoModalLowerDescription: React.FC<InfoModalLowerDescriptionProps> = ({
  lowerDescriptionTextKeys,
}) => {
  const i18n = useI18n();

  return (
    <>
      <S.Description>
        {i18n(lowerDescriptionTextKeys.main)}
        {lowerDescriptionTextKeys.important && (
          <>
            {' '}
            <strong>{i18n(lowerDescriptionTextKeys.important)}</strong>
          </>
        )}
      </S.Description>
      <S.ListItemDot key="content-dot-point-1">
        <S.MidDoT>&#8226;</S.MidDoT>
        {i18n(lowerDescriptionTextKeys.dot1)}
      </S.ListItemDot>
      <S.ListItemDot key="content-dot-point-2">
        <S.MidDoT>&#8226;</S.MidDoT>
        {i18n(lowerDescriptionTextKeys.dot2)}
      </S.ListItemDot>
    </>
  );
};

export default InfoModalLowerDescription;
